import { render, staticRenderFns } from "./manageCalled.vue?vue&type=template&id=2b4fbc00&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./manageCalled.vue?vue&type=style&index=0&id=2b4fbc00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4fbc00",
  null
  
)

export default component.exports